import { nominatimApi } from "../BaseService";
export const getReverseLocation = async (lat, lng) => {
    const api = nominatimApi();
    const response = await api.get(`/reverse?format=jsonv2&lat=${lat}&lon=${lng}`);
    return response.data;
};
